import createIcon from '../../createIcon';

/**
 * @component @name ImageAspectRatio
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgMTBIMTRWMTJIMTZWMTBaTTE2IDE0SDE0VjE2SDE2VjE0Wk04IDEwSDZWMTJIOFYxMFpNMTIgMTBIMTBWMTJIMTJWMTBaTTIwIDRINEMyLjkgNCAyIDQuOSAyIDZWMThDMiAxOS4xIDIuOSAyMCA0IDIwSDIwQzIxLjEgMjAgMjIgMTkuMSAyMiAxOFY2QzIyIDQuOSAyMS4xIDQgMjAgNFpNMjAgMThINFY2SDIwVjE4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ImageAspectRatio = createIcon('ImageAspectRatio', [
  [
    'path',
    {
      d: 'M16 10H14V12H16V10ZM16 14H14V16H16V14ZM8 10H6V12H8V10ZM12 10H10V12H12V10ZM20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V6H20V18Z',
      key: 'wm7z1j',
    },
  ],
]);

export default ImageAspectRatio;
